module.exports = __webpack_public_path__ + "img/zwu.03c726d6.png";